import {Howl, Howler} from 'howler';
import * as util from "@/vendor/util";

// import {ebus} from "../vendor/ebus";

//https://github.com/goldfire/howler.js/

let duringInit = true;
// let alarmPlaying = false;
let takeawayOrderSoundPlaying = false;
let takeawayDrinksSoundPlaying = false;

// let alarmSound = new Howl({
//     // src: ['sound1.mp3']
//     src: ['ska.mp3', 'ska.wav'],//['alarm1.mp3', 'alarm1.wav'],
//     loop: true
// });
let takeawayOrderSound, takeawayDrinkSound = null;

export function init() {
    let isIos = util.isIos();
    if (!takeawayOrderSound) {
        takeawayOrderSound = new Howl({
            src: ['takeawayOrder.mp3'],//['alarm1.mp3', 'alarm1.wav'],
            volume: 1,
            loop: !isIos,
            html5: isIos,
        });
    }
    if (!takeawayDrinkSound) {
        takeawayDrinkSound = new Howl({
            src: ['takeawayDrinks.mp3'],//['alarm1.mp3', 'alarm1.wav'],
            volume: 1,
            loop: !isIos,
            html5: isIos,
        });
    }
    duringInit = false;
}

export function doChangeVolume(vol) {
    if (duringInit) {
        return;
    }
    try {
        takeawayOrderSound.volume(vol);
        takeawayDrinkSound.volume(vol);
    } catch (e) {
        console.log('Error changing volume: ' + e.message)
    }
}

// export function doPlayAlarm() {
//     if(duringInit){
//         return;
//     }
//     // if (!alarmPlaying && alarmSound) {
//     //     try {
//     //         alarmSound.play();
//     //         alarmPlaying = true;
//     //     } catch (e) {
//     //         alert('Error playing Alarm Sound: '+e.message);
//     //     }
//     // }
// }

// export function doStopAlarm() {
//     if(duringInit){
//         return;
//     }
//     try {
//         alarmPlaying = false;
//         alarmSound.stop();
//     } catch (e) {
//     }
// }

let parentNode = null;

export function doPlayTakeawayOrderSound(force) {
    if (duringInit) {
        return;
    }
    console.log('try doPlayTakeawayOrderSound... ');
    if ((!takeawayOrderSoundPlaying || force) && takeawayOrderSound) {
        try {
            if ( util.isIos()) {
                console.log(' nn aa 1');
                // window.document.getElementById('s-order').src = 'takeawayOrder2x.mp3';
                console.log(' nn aa 2');
                let x = window.document.getElementById('a-order');
                console.log(' nn aa 3');
                x.loop = true;
                // x.load();
                x.play();
                console.log(' nn aa 4');
                //loop does not work so make my own loop
                // let i = setInterval(() => {
                //     if (takeawayOrderSoundPlaying) {
                //         console.log('reload audio element...');
                //         if (!parentNode) {
                //             parentNode = x.parentNode;
                //         }
                //         parentNode.removeChild(x);
                //         setTimeout(() => {
                //             parentNode.appendChild(x);
                //             // x.load();
                //             setTimeout(() => {
                //                 x.play();
                //             }, 200);
                //         }, 200);
                //     } else {
                //         clearInterval(i);
                //     }
                // }, 7000);
                return;
            }
            takeawayOrderSound.play();
            takeawayOrderSoundPlaying = true;
            console.log('doPlayTakeawayOrderSound started');
        } catch (e) {
            alert('Error doPlayTakeawayOrderSound: ' + e.message);
        }
    }
}

export function doStopTakeawayOrderSound() {
    if (duringInit) {
        return;
    }
    console.log('try doStopTakeawayOrderSound... ');
    try {
        takeawayOrderSound.stop();
        takeawayOrderSoundPlaying = false;
        if ( util.isIos()) {
            let x = window.document.getElementById('a-order');
            x.pause();
        }
        console.log('doStopTakeawayOrderSound stopped');
    } catch (e) {
        console.log('Error doStopTakeawayOrderSound');
    }
}

/////////////////////////////////

export function doPlayTakeawayDrinkSound(force) {
    if (duringInit) {
        return;
    }
    console.log('try doPlayTakeawayDrinkSound... ');
    if ((!takeawayDrinksSoundPlaying || force) && takeawayDrinkSound) {
        try {
            if ( util.isIos()) {
                // window.document.getElementById('s-drinks').src = 'takeawayDrinks2x.mp3';
                let x = window.document.getElementById('a-drinks');
                x.loop = true;
                // x.load();
                x.play();
                //loop does not work so make my own loop
                // let i = setInterval(() => {
                //     if (takeawayDrinksSoundPlaying) {
                //         x.play();
                //     } else {
                //         clearInterval(i);
                //     }
                // }, 7000);
                return;
            }
            takeawayDrinkSound.play();
            takeawayDrinksSoundPlaying = true;
            console.log('doPlayTakeawayDrinkSound started');
        } catch (e) {
            alert('Error doPlayTakeawayDrinkSound: ' + e.message);
        }
    }
}

export function doStopTakeawayDrinkSound() {
    if (duringInit) {
        return;
    }
    console.log('try doStopTakeawayDrinkSound... ');
    try {
        takeawayDrinkSound.stop();
        takeawayDrinksSoundPlaying = false;
        if ( util.isIos()) {
            let x = window.document.getElementById('a-drinks');
            x.pause();
        }
        console.log('doStopTakeawayDrinkSound stopped');
    } catch (e) {
        console.log('Error doStopTakeawayDrinkSound');
    }
}

export function stopAll() {
    doStopTakeawayDrinkSound();
    doStopTakeawayOrderSound();
}
